import React from "react";
import { ColumnValueRendererProps, DateColumnValue } from "../table.data.interface";
import { Tooltip } from "@vibe/core";
import moment from "moment";

const DateColumn = ({ columnData, isPreview, otherBoardsValues }: ColumnValueRendererProps) => {
  const value = columnData?.value;
  const dateObj =
    value != null && typeof value === "object" && "date" in value
      ? (value as DateColumnValue)
      : null;
  const dateFromValue = dateObj
    ? [dateObj.date, dateObj.time].filter(Boolean).join(" ")
    : undefined;

  const dateValue = otherBoardsValues
    ? dateFromValue
    : isPreview
      ? columnData.text
      : columnData.value;

  // Ensure we have a valid date value and it's a string or number
  if (!dateValue || (typeof dateValue !== "string" && typeof dateValue !== "number")) {
    return null;
  }

  // Other boards dates are in UTC; parse as UTC and convert to user's timezone
  const momentDate =
    otherBoardsValues && dateFromValue ? moment.utc(dateFromValue).local() : moment(dateValue);

  // Check if the parsed date is valid
  if (!momentDate.isValid()) {
    return null;
  }

  // Check if the date has time information by seeing if it's not at start of day
  const hasTime = !momentDate.clone().startOf("day").isSame(momentDate);

  // Format with time if time component exists, otherwise just date
  const formattedDate = hasTime
    ? momentDate.format("MMM D, YYYY h:mm A")
    : momentDate.format("MMM D, YYYY");

  if (isPreview) {
    return (
      <div className="flex overflow-hidden">
        <Tooltip content={formattedDate}>
          <p className="text-sm font-medium truncate whitespace-nowrap">{formattedDate}</p>
        </Tooltip>
      </div>
    );
  }

  return (
    <Tooltip content={formattedDate}>
      <div className="font-semibold">{formattedDate}</div>
    </Tooltip>
  );
};

export default DateColumn;
